import RecheckPassword from './RecheckPassword';

export default RecheckPassword;
